import React from "react";

import dayjs from "dayjs";

import { IconDownload } from "@synthesis/shared-icons";

import { Button, ScrollArea, Tooltip } from "@synthesis/shared-ui";

import { useStores } from "../../../store";
import type { FileMetaDto } from "../../../api";
import { DragAndDropVersions } from "../../drag-and-drop-versions";
import { useVersions } from "../hooks";

type VersionsProps = {
  selectedId: string;
};

const Versions = React.memo<VersionsProps>(({ selectedId }) => {
  const { fileStore } = useStores();
  const { isLoading, versions, postVersion } = useVersions(selectedId);

  const handleDownloadVersion = (fileMeta: FileMetaDto) => {
    fileStore.downloadFile({
      id: fileMeta.id,
      baseName: fileMeta.baseName || "Безымянный",
      ext: fileMeta.ext ?? "",
    });
  };

  const versionsContent = versions?.map((data, id) => {
    const fileMeta = data.fileMeta;
    if (!fileMeta) return null;
    return (
      <div className="my-4 px-4" data-cy="versions-bodyWrapper" key={id}>
        <div className="flex justify-between">
          <div className="max-w-96">
            <h2 className="overflow-hidden overflow-ellipsis text-sm font-medium">{fileMeta.baseName}</h2>
            <p className="text-xs text-gray-500">
              {typeof fileMeta.modifiedAt === "number" && dayjs.unix(fileMeta.modifiedAt).format("DD.MM.YYYY HH:mm:ss")} | {fileMeta.size} байт
            </p>
          </div>
          <Tooltip description="Скачать версию">
            <Button
              theme="text"
              leftIcon={<IconDownload data-cy="versions-iconCloud" className="size-6 text-[#eb0000]" />}
              onClick={() => handleDownloadVersion(fileMeta)}
            />
          </Tooltip>
        </div>
      </div>
    );
  });

  return (
    <ScrollArea className="h-[75vh]">
      {!isLoading ? versionsContent : loadingContent}
      <DragAndDropVersions selectedId={selectedId} postVersion={postVersion} />
    </ScrollArea>
  );
});

const loadingContent = (
  <div className="px-4 pt-4">
    <div className="flex flex-wrap">
      {Array.from(Array(2), (_, i) => (
        <div className="bg-grey-300 mb-3 h-10 w-full animate-pulse rounded bg-opacity-30" key={i} />
      ))}
    </div>
  </div>
);

export default Versions;
